import { useState } from "react";
import RefreshButton from "../../../../components/RefreshButton";
import SearchButton from "../../../../components/SearchButton";
import TextInput from "../../../../components/TextInput";

const TableFilters = ({
  filterText,
  moduleDetails,
  textInputName,
  disabledButton,
  setIsSearching,
  setIsFilter,
  setIsFromRedirection,
}) => {
  const [inputValue, setInputValue] = useState("");

  const filterData = () => {
    filterText(inputValue);
    setIsFilter(true);
    setIsSearching(true);
    setIsFromRedirection(false);
  };
  return (
    <div>
      <div className="flex flex-row space-x-2">
        <TextInput
          type={textInputName}
          name={textInputName}
          value={inputValue}
          placeholder={moduleDetails}
          onChange={(e: any) => {
            setInputValue(e ? e.target.value : "");
          }}
        />
        <SearchButton
          buttonValue="Search"
          className={
            disabledButton || inputValue === "" ? "opacity-50" : "opacity-100"
          }
          disabled={disabledButton || inputValue === "" ? true : false}
          onClick={() => {
            filterData();
          }}
        />
        <div>
          <RefreshButton
            className={
              disabledButton || inputValue === "" ? "opacity-50" : "opacity-100"
            }
            disabled={disabledButton || inputValue === "" ? true : false}
            onClick={() => {
              setInputValue("");
              setIsFilter(false);
              setIsSearching(false);
              setIsFromRedirection(false);
            }}
          />
        </div>
      </div>
    </div>
  );
};
export default TableFilters;
